import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, inject } from '@angular/core'

import { ApiPreofferService } from '@data/services/modules/preoffer/api-preoffer.service'
import { AuthService } from '@data/services/modules/auth/auth.service'
import { PreofferView, preofferView } from '../preoffer-view.util'

/**
 * Plan v4.3 §9.3 y §2b · Píldora de la preoferta en el encabezado del arrendamiento, junto a la de situación: es la de su
 * cliente (D-72). Solo se pinta si hay una preoferta vigente y quien mira tiene el módulo.
 */
@Component({
  selector: 'app-preoffer-pill',
  templateUrl: './preoffer-pill.component.html',
  styleUrls: ['./preoffer-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreofferPillComponent implements OnChanges {
  @Input() leaseId: string | null = null

  private readonly api = inject(ApiPreofferService)
  private readonly cdr = inject(ChangeDetectorRef)
  private readonly canView = inject(AuthService).hasModulePermission('lease-preoffer', 'view')
  view: PreofferView | null = null

  ngOnChanges(): void {
    this.view = null
    if (!this.leaseId || !this.canView) return
    this.api.byLease(this.leaseId).subscribe((response) => {
      this.view = response.error ? null : preofferView(response.data?.current)
      this.cdr.markForCheck()
    })
  }
}
